import React, { useEffect, useState, useRef, useCallback } from "react";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import lar from "../../Assets/svg/lar.svg";
import rar from "../../Assets/svg/rar.svg";
import ReactPaginate from "react-paginate";
import DeleteModal from "../common/DeleteModal";
import ListFooter from "../common/ListFooter.jsx";
import ReportButton from "../common/ReportButton.jsx";
import { useExcelActions } from "../../hooks/useExcelActions";
import { Link, useNavigate } from "react-router-dom";
import edit from "../../Assets/svg/edit.svg";
import dt from "../../Assets/svg/delete.svg";
import { useGlobal } from "../../GlobalContext.js";
import { apiCall } from "../../services/api-service.js";

const ApprovalList = () => {
  const { rolePermissionList } = useGlobal();
  const navigate = useNavigate();
  const [approvalList, setApprovalList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const status = "All";
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }

  useEffect(() => {
    getListData(searchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, itemsPerPage, itemOffset]);

  const handlePageClick = useCallback(
    (event) => {
      const newOffset = event.selected * itemsPerPage;
      setItemOffset(newOffset);
    },
    [itemsPerPage]
  );
  const [deleteId, setDeleteId] = useState(null);
  const deleteTeam = (id) => {
    setDeleteId(id);
    setIsOpenDelete(true);
  };

  const deleteApi = async () => {
    if (deleteId == null) {
      return;
    }

    const response = await apiCall("delete", `approval/${deleteId}`);
    setSnackbarMessage(response?.data?.message ?? "");
    setSnackbarStatus(response?.data?.success === true);
    handleSnackbarShow();

    if (response?.data?.success === true) {
      setDeleteId(null);
      setIsOpenDelete(false);
      getListData("");
    }
  };
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const handleSearch = debounce((term) => {
    // A new search starts from the first page. If already on page 1, fetch
    // directly; otherwise reset the offset and let the itemOffset effect fetch.
    if (itemOffset === 0) {
      getListData(term, 0);
    } else {
      setItemOffset(0);
    }
  }, 300);

  const getListData = async (term, skip = itemOffset) => {
    const response = await apiCall("get", "approval", null, {
      params: {
        limit: itemsPerPage,
        skip,
        search: term,
        status,
      },
    });

    if (response?.data?.success === true) {
      const totalPages = response.data.total_pgs ?? 0;
      setTotalCount(response.data.total_rec ?? 0);
      setPageCount(totalPages);
      setApprovalList(response.data.approvals ?? []);

      // Snap back to the last page if the current page is now out of range.
      const currentPage = Math.floor(skip / itemsPerPage);
      if (currentPage > totalPages) {
        setItemOffset(totalPages * itemsPerPage);
      }
    }
  };

  const { reportLoading, downloadReport } = useExcelActions("approval", getListData, {
    setSnackbarMessage,
    setSnackbarStatus,
    handleSnackbarShow,
  }, "approval_configurations");

  return (
    <Container
      fluid
      style={{ width: "100%", padding: "0px", fontFamily: "Satoshi" }}
    >
      <div className="d-flex side4">
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            // height: "100vh",
            overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <div className="maincontent3">
              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ gap: "12px" }}>
                  <div>
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "20px",
                        lineHeight: "22px",
                        color: "#212129",
                      }}
                    >
                      Approval Configuration
                    </span>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#8790A1",
                      }}
                    >
                      Manage your approval and create new configured approval
                      here
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  
                  {checkPermission("Approval", "create_permission") && (
                    <Link to="/approval/add" className="nav-link">
                      <button
                        style={{
                          height: "40px",
                          borderRadius: "100px",
                          padding: "8px 16px 8px 16px",
                          gap: "8px",
                          backgroundColor: "#6929E2",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "none",
                        }}
                      >
                        <p
                          style={{
                            margin: "0",
                            fontFamily: "Satoshi",
                            fontWeight: "700",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#FFFFFF",
                          }}
                        >
                          + Create Approval
                        </p>
                      </button>
                    </Link>
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "16px",
                }}
                className="mb-3"
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "14px",
                      lineHeight: "22px",
                      color: "#212129",
                      margin: "0",
                    }}
                  >
                    Total approvals:{totalCount}{" "}
                  </p>
                </div>

                <div
                  style={{
                    height: "40px",
                    gap: "12px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: "16px",
                  }}
                >
                  <div>
                    <input
                      type="search"
                      placeholder="Search..."
                      onChange={(event) => {
                        setSearchTerm(event.target.value);
                        handleSearch(event.target.value);
                      }}
                      style={{
                        width: "300px",
                        height: "40px",
                        borderRadius: "100px",
                        border: "0.5px solid #E5E5E5",
                        padding: "14px 16px 14px 16px",
                        gap: "6px",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  </div>
<ReportButton
                    loading={reportLoading}
                    onClick={() => downloadReport({ status, search: searchTerm })}
                  />
                  {/*  <button style={{ display: "flex", alignItems: "center", gap: "4px", border: "0.6px solid #D4DDE7", borderRadius: "100px", background: "#FFFFFF", cursor: "pointer" }} className="px-3 py-2">
                                        <img src={filter} style={{ width: "16px", height: "16px" }} alt="Filter Icon" />
                                        Filter
                                    </button> */}
                </div>
              </div>

              <div
                className="d-flex flex-column py-3"
                style={{ borderRadius: "8px", backgroundColor: "#FFFFFF" }}
              >
                <div
                  className="py-3 px-4 d-flex col-12"
                  style={{ backgroundColor: "#F2F2F2" }}
                >
                  <div
                    className="col-2"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Name
                  </div>
                  <div
                    className="col-2"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Region
                  </div>
                  <div
                    className="col-2"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Location
                  </div>
                  <div
                    className="col-3"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Project
                  </div>
                  <div
                    className="col-3"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Component
                  </div>
                </div>
                <div>
                  {approvalList.map((item, index) => (
                    <div
                      key={"table-list" + index}
                      style={{ position: "relative", cursor: "pointer" }}
                    >
                      <div
                        className="py-2 px-3 d-flex col-12"
                        style={{
                          backgroundColor: "#FFFFFF",
                          borderBottom: "0.6px solid #D4DDE7",
                        }}
                      >
                        <div
                          className="col-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          {item.name}
                        </div>
                        <div
                          className="col-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          {item.region}
                        </div>
                        <div
                          className="col-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                            display: "-webkit-box",
                            WebkitLineClamp: 2, // max 5 lines
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden", // hide overflow
                            textOverflow: "ellipsis", // show "..." if text is too long
                          }}
                          title={item.location}
                        >
                          {item.location}
                        </div>
                        <div
                          className="col-3"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          {item.project}
                        </div>
                        <div
                          className="col-3"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span
                              style={{
                             
                                flex: "3",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {item.component ?? ""}{" "}
                            </span>

                            {checkPermission("Approval", "edit_permission") && (
                              <div
                                onClick={() => {
                                  navigate("/approval/add", {
                                    state: { id: item.id },
                                  });
                                }}
                                style={{
                                  marginLeft: "16px",
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                  gap: "10px",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                <img
                                  src={edit}
                                  style={{ width: "14px", height: "14px" }}
                                />
                              </div>
                            )}

                            {checkPermission(
                              "Approval",
                              "delete_permission"
                            ) && (
                              <div
                                onClick={() => {
                                  deleteTeam(item.id);
                                }}
                                style={{
                                  marginLeft: "8px",
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                  gap: "10px",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                <img
                                  src={dt}
                                  style={{ width: "14px", height: "14px" }}
                                />
                              </div>
                            )}
                          </div>
                          {/* <select style={{ fontWeight: '500', fontSize: '14px', color: '#212129', background: 'transparent', border: 'none', outline: 'none', cursor: 'pointer' }}>
                                            <option value="active">🟢 Active</option>
                                            <option value="inactive">🔴 Inactive</option>
                                        </select> */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <ListFooter
                  itemsPerPage={itemsPerPage}
                  onItemsPerPageChange={(n) => {
                    setItemsPerPage(n);
                    setItemOffset(0);
                  }}
                  pagination={
                    <ReactPaginate
                      previousLabel={
                        <img src={lar} className="ar3" alt="previous" />
                      }
                      nextLabel={<img src={rar} className="ar3" alt="next" />}
                      breakLabel={"..."}
                      pageCount={pageCount + 1}
                      forcePage={Math.min(
                        Math.floor(itemOffset / itemsPerPage),
                        pageCount
                      )}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                    />
                  }
                />
              </div>

              <div className="d-flex justify-content-center align-items-center">
                {/* <div >
                                    <div className="d-flex align-items-center justify-content-start mx-3">
                                        <span style={{ fontFamily: 'Satoshi', fontSize: '13px', fontWeight: '500', color: '#212129', }}>Records per page :</span>
                                        <select className="select3" id="perpage" style={{ cursor: 'pointer', fontFamily: 'Satoshi', fontSize: '14px', fontWeight: '500', lineHeight: '18.9px', color: '#212129', width: '56px', height: '24px', borderRadius: '10px', border: '0.7px solid #E5E5E5', padding: '0 4px', backgroundColor: '#FFFFFF' }}>
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="30">30</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>

                                </div> */}

                <div>
                  <div className=""></div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <DeleteModal
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteApi}
        title="Delete Approval Config"
        message="You won’t able to access your config after deleting. Are you sure want to delete?"
      />
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
                                                                        <strong className="mr-auto">Snackbar Title</strong>
                                                                      </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default ApprovalList;
